var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StrokeButton',{attrs:{"plain":"","size":"middle","type":"primary"},on:{"click":_vm.getCSV}},[_vm._v("\n  "+_vm._s(_vm.$t('EXPORT_CSV'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }